import { useLiveStreamsUsageLimits } from "@circle-react/components/LiveStreams/hooks";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";

import { LazyCompassGoLiveModal } from "@/react/components/LiveStreams/CompassGoLiveModal/LazyCompassGoLiveModal";

export interface GoLiveProps {
  isPreviewMode?: boolean;
}

export const GoLive = ({ isPreviewMode = false }: GoLiveProps) => {
  const { currentCommunityMember, isViewOnlyMasquerading } =
    usePunditUserContext();

  const {
    isPending: areLiveLimitsLoading,
    isMonthlyHourLimitReached,
    isStorageLimitReached,
  } = useLiveStreamsUsageLimits({ enabled: !!currentCommunityMember });

  const areLiveLimitsReached =
    isMonthlyHourLimitReached || isStorageLimitReached;
  const shouldDisableGoLiveButton =
    !isCommunityAdmin(currentCommunityMember) &&
    (areLiveLimitsLoading || areLiveLimitsReached);
  const isInteractionDisabled =
    isViewOnlyMasquerading || shouldDisableGoLiveButton;

  return (
    <LazyCompassGoLiveModal
      disabled={isInteractionDisabled}
      isPreviewMode={isPreviewMode}
    />
  );
};
